interface ServiceRequestOwnership {
  createdBy: string;
  submitOnBehalfOf?: string | null;
}

// An admin who submits for a tenant is not the owner; the tenant is.
export const resolveServiceRequestOwnerId = (
  serviceRequest: ServiceRequestOwnership
): string => serviceRequest.submitOnBehalfOf || serviceRequest.createdBy;
